
import React, { useState, useEffect } from 'react';
import * as styles from "./style.module.css"

const IAMNETCONSENTELEMENTID="iamnetconsentelementid";

const IamnetConsent = ({location, geticon}) => {
	const [agreedpolicy, setAgreedpolicy] = useState(true);

	// This runs when the page is loaded.
	useEffect(() => {
		function loadLocalstorageConsent()
		{
			try {
				var consentobj = JSON.parse(localStorage.getItem(IAMNETCONSENTELEMENTID));
				if (consentobj === null) {
					consentobj = {};
				}
				if (consentobj.hasOwnProperty("all")) {
					setAgreedpolicy(consentobj.all === true);
					return true;
				}
			} catch (e) {

			}
			return false;
		}
		if (loadLocalstorageConsent() === true) {
			return;
		}

		// So next page navigated will show consent without timeout
		localStorage.setItem(IAMNETCONSENTELEMENTID, JSON.stringify({ "all": false}));

		// Delay display of consent
		const delaytimerID = setTimeout(() => {
			// This should prevent popup if cookie is disabled
			if (typeof navigator !== "undefined") {
				if (navigator.cookieEnabled) {
					loadLocalstorageConsent();
				}
			}
		}, 1000);

		// Clear the timeout if the component unmounts
		return () => {
			clearTimeout(delaytimerID);
		};
	}, []);


	const acceptPolicy = function(e) {
		var consentobj = {};
		try {
			consentobj = JSON.parse(localStorage.getItem(IAMNETCONSENTELEMENTID));
			if (consentobj === null) {
				consentobj = {};
			}
		} catch (e) {
			consentobj = {};
		}
		consentobj.all = true;
		localStorage.setItem(IAMNETCONSENTELEMENTID, JSON.stringify(consentobj));
    	setAgreedpolicy(true);
	}
	const loadPolicy = function(e, dest) {
		if (e) {
			e.preventDefault();
		}
		window.open("/"+dest, "_blank");
	}

	const showNPCSeal = function(className) {
		return <a className={className} href="https://cdn.iamnetph.com/official/img/npc/20250211high.png" target={"_blank"}  rel={"noreferrer"} title={"NPC Seal of Registration"}>
			<img sizes="10vw" src="https://cdn.iamnetph.com/official/img/npc/20250211tiny.png" alt="NPC Registration" srcset="https://cdn.iamnetph.com/official/img/npc/20250211tiny.png 128w, https://cdn.iamnetph.com/official/img/npc/20250211.png 256w, https://cdn.iamnetph.com/official/img/npc/20250211med.png 512w, https://cdn.iamnetph.com/official/img/npc/20250211high.png 1024w" />
		</a>
	}

	if (typeof geticon !== "undefined") {
		if (geticon === true) {
			return showNPCSeal(styles.iamnetconsenticonmode);
		}
	}

	// Check if path is an agreement page, hide consent to make it readable
	const pathlist = location?(location.hasOwnProperty("pathname")?(location.pathname?location.pathname.split("/"):[]):[]):[];
	var parentpath = "";
	if (pathlist.length > 0) {
		var tmpidx = 0;
		while (tmpidx < pathlist.length) {
			if (pathlist[tmpidx].length > 0) {
				parentpath = pathlist[tmpidx]
				break;
			}
			tmpidx++;
		}
	}
	const agreementpagelist = ["privacy", "terms"]
	const hideconsentform = agreedpolicy?agreedpolicy:agreementpagelist.includes(parentpath);
	return (<>
		{hideconsentform === false ?
			<div
				role="alertdialog"

				data-modal="true"
				data-webviewid="cookie-overlay"

				aria-modal="true"
				aria-labelledby="dialog_label"
				aria-describedby="dialog_desc"

				className={styles.iamnetconsent}
			>
				<div className={styles.iamnetconsenttext}>
					{showNPCSeal(styles.iamnetconsentqrcode)}
					<div className={styles.iamnetconsenttextbody}>
						<div>
							Please click "I Accept", to confirm that you have read, understood and agree to the <button className={styles.link} onClick={(e)=>{loadPolicy(e, "terms")}}>Terms & Conditions</button> and <button className={styles.link} onClick={(e)=>{loadPolicy(e, "privacy")}}>Privacy Policy</button> before continuing to browse and use this website. Access to and use of NegosyoNow.com is contingent upon your acceptance and compliance with these agreements.  They apply to all visitors, users, and anyone who accesses or utilizes the Service.
						</div>
						<span className={styles.iamnetconsentactionarea}>
							<button className={styles.button} onClick={acceptPolicy}>
								I Accept
							</button>
						</span>
					</div>

				</div>
			</div>
		:
			<></>
		}
	</>)

}

export default IamnetConsent
